import { cn } from '@/lib/utils';

export function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        // Shimmer sweep instead of a flat pulse — grey base with a soft
        // Atmosphere highlight passing through (see `shimmer` keyframes).
        'animate-shimmer rounded-md bg-secondary bg-[linear-gradient(110deg,transparent_30%,hsl(var(--info-soft)/0.25)_50%,transparent_70%)] bg-[length:200%_100%]',
        className,
      )}
      {...props}
    />
  );
}
